export const DEFAULT_LOGO_IMAGE = 'https://ik.imagekit.io/torimapp/no-image_OU9SfsTMS.png';

